import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from "../../../datatype-library/index";

export class BankReconEditCashbookBalancesOutputDto extends BaseContainerModel {
    lastCashbookClosingBalance: fromDatatype.NumericDatatypeInterface;
    lastCashbookClosingBalanceCalculated:fromDatatype.NumericDatatypeInterface;
    lastCashbookBankStmtClosingBalance: fromDatatype.NumericDatatypeInterface;
    latestReconClosingBalanceCalculated: fromDatatype.NumericDatatypeInterface;
    latestReconSumBankStm: fromDatatype.NumericDatatypeInterface;
    latestReconTotalBankStm: fromDatatype.NumericDatatypeInterface;

}